import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/shared/user.service';
import { EmSignerConfig } from './contract.model';

interface ApiResponse<T> {
  isSuccess: boolean;
  status: number;
  message: string;
  body: T;
}

@Injectable({
  providedIn: 'root'
})
export class EmSignerService {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
    private userService: UserService
  ) {
    this.baseUrl = environment.contractApiURL;
  }

  saveConfig(config: EmSignerConfig) {
    return this.http.post<ApiResponse<EmSignerConfig>>(
      `${this.baseUrl}/emsigner_creds/${this.userService.loggedinUser.tenantId}`,
      config
    );
  }

  getConfig() {
    return this.http.get<ApiResponse<EmSignerConfig>>(
      `${this.baseUrl}/emsigner_creds/${this.userService.loggedinUser.tenantId}`
    );
  }
} 